// extracted by mini-css-extract-plugin
module.exports = {"modal":"VoiceModaDisabledModal_modal___oQBi","text":"VoiceModaDisabledModal_text__2XgVE","button":"VoiceModaDisabledModal_button__p_3UE"};